module.exports = {
  APP_NAME: "DTP",
};
